import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  animate?: boolean;
}

export function Card({ children, className = '', animate = true }: CardProps) {
  const Component = animate ? motion.div : 'div';

  const animationProps = animate
    ? {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.3 },
      }
    : {};

  return (
    <Component
      className={`bg-white dark:bg-gray-800 rounded-3xl shadow-[0_1px_2px_rgba(16,24,40,0.04)] p-6 transition-colors duration-200 ${className}`}
      {...animationProps}
    >
      {children}
    </Component>
  );
}
